import Toast, { ToastType } from "react-native-toast-message";
import { VDBIcons } from "@utils/VDBIcons";
import { DefaultTheme } from "styled-components/native";
import { isIPhone, isSafari } from "@utils/design-tokens";
import { ExportStatus } from "@src/types/ExportsResult";
import { Platform } from "react-native";

const getSafeBottomInset = () => {
  if (
    typeof window !== "undefined" &&
    "CSS" in window &&
    window.CSS.supports("height", "env(safe-area-inset-bottom)")
  ) {
    return "env(safe-area-inset-bottom, 40px)";
  }
  return 40;
};

export const showToast = (
  title?: string,
  description?: any,
  messageType?: ToastType,
  iconEnabled1?: boolean,
  closeIconEnabled1?: boolean,
  bottomMargin?: number,
  onNotificationPress?: () => void,
  autoHide = true,
  visibilityTime = 4000,
  showProgressBar: boolean = false,
  progress: number = 0,
  downloadUrl?: string,
  cancelExport?: (status: ExportStatus) => void,
  onHide?: () => void,
  iosBottomOffset?: number
) => {
  Toast.show({
    type: "vdbToast",
    props: {
      type: messageType,
      iconEnabled: iconEnabled1,
      closeIconEnabled: closeIconEnabled1,
      onNotificationPress: onNotificationPress,
      showProgressBar: showProgressBar,
      progress: progress ? progress : 0,
      downloadUrl: downloadUrl ? downloadUrl : undefined,
      cancelExport: cancelExport ? cancelExport : undefined,
    },
    text1: title,
    text2: description,
    position: "bottom",
    autoHide: autoHide,
    bottomOffset:
      isIPhone() && isSafari()
        ? getSafeBottomInset()
        : bottomMargin && progress
        ? bottomMargin
        : Platform.OS === "android"
        ? bottomMargin
        : iosBottomOffset ?? 40,
    visibilityTime: visibilityTime,
    swipeable: false,
    onHide: onHide,
  });
};

export enum ToastTypes {
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info",
  NOTIFICATION = "notification",
  LABGROWN_JEWELRY = "lab-grown jewelry",
  DOWNLOAD = "download",
}

export const getToastIcon = (toastType: string) => {
  switch (toastType) {
    case "error":
      return VDBIcons.WARNING;
    case "success":
      return VDBIcons.CHECKMARK;
    case "notification":
      return VDBIcons.REQUEST_HISTORY;
    case "info":
      return VDBIcons.MESSAGE;
    case "lab-grown jewelry":
      return VDBIcons.MESSAGE;
    case "download":
      return VDBIcons.DOCUMENT_DOWNLOAD;
    default:
      return VDBIcons.MESSAGE;
  }
};

export const getToastColor = (toastType: string, theme: DefaultTheme) => {
  switch (toastType) {
    case "error":
      return theme["error-01"];
    case "success":
      return theme["success-01"];
    case "notification":
      return theme["success-01"];
    case "info":
      return theme["warn-01"];
    case "lab-grown jewelry":
      return theme["jewelry-01"];
    case "download":
      return theme["warn-01"];
    default:
      return theme["warn-01"];
  }
};
